'use client';

import { usePathname } from 'next/navigation';

function matchWildCardPath(currentPath: string, path: string) {
    const pathToMatch = path.replace('/*', '');
    // Match on a path-SEGMENT boundary, not a raw substring: the prefix must be the
    // whole tail (`…/admin/ai-search`) or be followed by a `/` (`…/admin/ai-search/x`).
    // A plain `includes` lit up sibling routes that merely share a prefix — e.g.
    // `/admin/ai-search-chats` contains `/admin/ai-search`, so BOTH items showed active.
    return currentPath.endsWith(pathToMatch) || currentPath.includes(`${pathToMatch}/`);
}

/** FIXME: This dsn't work with query params etc */
export default function useIsActivePath(paths: string | string[]): boolean {
    const currentPath = usePathname();
    if (Array.isArray(paths)) {
        return paths.some(path =>
            currentPath.endsWith(path) || path.endsWith('*')
                ? matchWildCardPath(currentPath, path)
                : false,
        );
    }
    if (paths.endsWith('*')) {
        return matchWildCardPath(currentPath, paths);
    }
    return currentPath.endsWith(paths);
}
